<template>
	<div>
		<modal
			:exibir="exibir"
			titulo="Supressão/Acréscimo de Quantidade"
			:max-width="450"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			@close="fecharModal"
			:acao-cancelar="fecharModal"
			:is-confirmar-desabilitado="isConfirmarDesabilitado"
		>
			<template #body>
				<v-form class="modal-supressao-acrescimo__form" ref="form" v-model="formIsValid" lazy-validation @submit.prevent>
					<div>
						<label-personalizado nome-campo="Tipo" class="mb-2"></label-personalizado>
						<v-radio-group v-model="tipoOperacao" row class="ma-0 py-0">
							<v-radio label="Acréscimo" :value="'ACRESCIMO'"></v-radio>
							<v-radio label="Supressão" :value="'SUPRESSAO'"></v-radio>
						</v-radio-group>
					</div>

					<v-row class="mb-1">
						<v-col cols="12">
							<label-personalizado
								nome-campo="Quantidade"
								:obrigatorio-por-padrao="true"
							></label-personalizado>
							<az-money
								required
								v-model="quantidade"
								placeholder="Informe quantidade"
								:negative="false"
								:requeridMessage="'Quantidade deve ser preenchido!'"
								:precision="aditivoApostila.numeroCasasDecimaisQtde"
								prefix=""
								class="ma-0 py-0"
								dense
								show-clear-button
							></az-money>
							<span
								v-if="quantitativoItens"
								class="green--text"
							>
								{{ tipoOperacao === 'SUPRESSAO' ? 'Supressão':'Acréscimo'}}:
								{{ percentualAcrescimoSupressao | rpCurrencyFilter('', aditivoApostila.numeroCasasDecimaisQtde) }}%
							</span>
						</v-col>
					</v-row>
				</v-form>
			</template>
		</modal>
	</div>
</template>

<script>
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'

export default {
	name: 'modal-supressao-acrescimo-aditivo-apostila',
	components: { LabelPersonalizado, Modal },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		quantitativoItens: {
			type: Number,
			required: true,
		},
	},
	emits: ['fechar-modal', 'salvar'],
	data() {
		return {
			idAditivoApostila: this.$route.params.idAditivoApostila,
			formIsValid: true,
		}
	},
	computed: {
		...mapState({
			aditivoApostila: (state) => state.aditivoApostila,
		}),
		tipoOperacao: {
			get() {
				return this.$store.state.itemAditivoApostila.tipoOperacao
			},
			set(value) {
				this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.SET_TIPO_OPERACAO, value)
			},
		},
		quantidade: {
			get() {
				return this.$store.state.itemAditivoApostila.quantidade
			},
			set(value) {
				this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.SET_QUANTIDADE_SUPRESSAO_ACRESCIMO, value)
			},
		},
		percentual() {
			return this.$store.state.parametrosSistema.percentualQuantitativoAcrescimoSupressao
		},
		isConfirmarDesabilitado() {
			return !this.percentual || !this.quantidade || !this.tipoOperacao || !this.formIsValid
		},
		percentualAcrescimoSupressao() {
			return (this.quantidade * 100) / this.quantitativoItens
		},
	},
	mounted() {
		this.validarFormulario()
	},
	methods: {
		async confirmar() {
			if (this.formIsValid) {
				const payload = {
					idAditivoApostila: this.idAditivoApostila,
					tipoOperacao: this.tipoOperacao,
					quantidade: this.quantidade,
				}
				this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.SET_INFORMACOES_ITEM_ADITIVO_APOSTILA, payload)
				this.$emit('salvar', payload)
				this.fecharModal()
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
			this.limparFormulario()
		},
		validarFormulario() {
			this.formIsValid = this.percentual && this.quantidade && this.tipoOperacao
		},
		limparFormulario() {
			this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.RESET_INFORMACOES_ITEM_ADITIVO_APOSTILA)
		},
	},
}
</script>

<style lang="stylus" scoped>
.modal-supressao-acrescimo__form
	margin-top: 0.9375rem

</style>
